import { useEffect, useRef } from 'react'
import './MatrixBackground.css'

export default function MatrixBackground() {
    const canvasRef = useRef<HTMLCanvasElement>(null)

    const mouseRef = useRef({ x: 0, y: 0 })

    useEffect(() => {
        const canvas = canvasRef.current
        if (!canvas) return

        const ctx = canvas.getContext('2d')
        if (!ctx) return

        canvas.width = window.innerWidth
        canvas.height = window.innerHeight

        const characters = '01アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン'
        const fontSize = 14
        const columns = canvas.width / fontSize

        const drops: number[] = []
        for (let i = 0; i < columns; i++) {
            drops[i] = Math.random() * -100
        }

        const handleMouseMove = (e: MouseEvent) => {
            mouseRef.current = { x: e.clientX, y: e.clientY }
        }

        function draw() {
            if (!ctx || !canvas) return

            ctx.fillStyle = 'rgba(10, 10, 15, 0.05)'
            ctx.fillRect(0, 0, canvas.width, canvas.height)

            ctx.font = `${fontSize}px monospace`

            for (let i = 0; i < drops.length; i++) {
                const text = characters[Math.floor(Math.random() * characters.length)]
                const x = i * fontSize
                const y = drops[i] * fontSize

                // Calculate distance from mouse
                const dx = x - mouseRef.current.x
                const dy = y - mouseRef.current.y
                const distance = Math.sqrt(dx * dx + dy * dy)
                const maxDistance = 300 // Radius of influence

                // Highlight color calculation
                if (distance < maxDistance) {
                    const intensity = 1 - distance / maxDistance
                    ctx.fillStyle = `rgba(0, 255, 136, ${0.1 + intensity})` // Brighter near cursor
                    ctx.shadowBlur = 10 * intensity
                    ctx.shadowColor = '#00ff88'
                } else {
                    ctx.fillStyle = '#0f382a' // Darker green for background
                    ctx.shadowBlur = 0
                }

                ctx.fillText(text, x, y)

                // Reset shadow for next iteration/performance
                ctx.shadowBlur = 0;

                if (y > canvas.height && Math.random() > 0.975) {
                    drops[i] = 0
                }

                drops[i]++
            }
        }

        const interval = setInterval(draw, 50)

        const handleResize = () => {
            canvas.width = window.innerWidth
            canvas.height = window.innerHeight
        }

        window.addEventListener('resize', handleResize)
        window.addEventListener('mousemove', handleMouseMove)

        return () => {
            clearInterval(interval)
            window.removeEventListener('resize', handleResize)
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [])

    return <canvas ref={canvasRef} className="matrix-background" />
}
